(function ($) {

  //Treure classes amb viewport > 768 relacionades amb el menú responsive
  var $window = $(window),
    $navegacio = $(".main-nav"),
    $hamb = $("button.hamburger"),
    $body = $(body);

  function resize() {
    if ($window.width() > 768) {
      return (
        $navegacio.removeClass("is-active is-mobile"),
        $hamb.removeClass("is-active"),
        $body.removeClass("is-active")
      );
    }
  }

  $window.resize(resize).trigger("resize");

  // TOT CLICABLE

  $(".is-clickable").on("click", function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  // (blank)
  $(".is-blank").on("click", function () {
    window.open($(this).find("a").attr("href"), "_blank");
    return false;
  });

  /**
   * Navegació principal amb submenus
   */

  //afegir la classe 'has-sub-menu a cada 'li' que conté submenu.
  $("#main-nav>ul>li:has(.sub-menu)").addClass('has-sub-menu');
  //afegir chevron a cada a que té submenu
  $("#main-nav>ul>li:has(.sub-menu)>a").append('<svg class="icon" aria-hidden="true" focusable="false"><use xlink:href="#right"></use></svg>');

  // Manejar clic en los enlaces para abrir/cerrar los submenús
  $("#main-nav>ul>li.has-sub-menu>a").click(function (event) {
    event.preventDefault(); // Previene la acción predeterminada del enlace
    // Oculta todos los submenús excepto el actual
    $(".sub-menu").not($(this).next(".sub-menu")).slideUp("fast");
    // Alterna el submenú actual
    $(this).next(".sub-menu").slideToggle("fast");
  });

  // Cerrar los submenús cuando se hace clic en cualquier parte fuera de ellos
  $(document).click(function (event) {
    // Verifica si el elemento clicado no es parte del submenú y no es un enlace de menú
    if (!$(event.target).closest("#main-nav>ul>li>a, .sub-menu").length) {
      $(".sub-menu").slideUp("fast"); // Oculta todos los submenús
    }
  });

  //ACORDIÓ ACCESSIBLE (https://a11y.nicolas-hoffmann.net/accordion/)

  $(".js-accordion").accordion({
    buttonsGeneratedContent: "html",
    multiselectable: false,
  });

  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)

  // bind a click event to the 'skip' link
  $(".skip-link").on("click", function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  //marcar label als changelogs

  $(".js-expandmore").on("click", function () {
    $(this)
      .parent()
      .prev(".column")
      .children()
      .children(".changelog--label")
      .toggleClass("is-active");
  });

  $(".sub-menu li.current-menu-item")
    .parent()
    .closest("li")
    .addClass("current-menu-item");

	var waitForEl = function(selector, callback) {
		if (jQuery(selector).length) {
		  callback();
		} else {
		  setTimeout(function() {
			waitForEl(selector, callback);
		  }, 100);
		}
	  };
	  
	if( $('#contact-form-typeform').length ) {
	  waitForEl('#contact-form-typeform iframe', function() {
		$('#contact-form-typeform iframe').ready(function(){
			var container = document.getElementById('contact-form-typeform');
			var iframe = container.querySelector('iframe');
			iframe.onload = function (e) {
				var iframeDocument = e.target.contentWindow.document;
				var style = document.createElement('style');
				style.textContent =
				'label {' +
				'	width: 100%;' + 
				'}' +
				'label span{' +
				'	display: block;' +
				'   font-size: 1.5rem;' +
				'   font-weight: 600;' +
				'   display: block;' +
				'   width: 100%;' +
				'   padding-bottom: .5rem;' + 
				'}' + 
				'input[type=text], input[type=email], input[type=tel], select {' +
				'display: block;' +
				'width: 100%;' +
				'height: 4.8rem;' +
				'background:#fff;' +
				'padding-right: 1.94rem;' +
				'padding-left: 1.94rem;' +
				'}' + 
				'textarea{ ' + 
				'display: block;' + 
				'width: 100%;' + 
				'background: #fff;' + 
				'padding: 1.94rem;' + 
				'}';
				console.log(iframeDocument);
				console.log(iframe.contentDocument.head.appendChild(style));
			}
		});
	  });
	}

  //Botó amunt
  /*
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 300) {
      $('a.capdamunt').addClass('mostrar');
      $('a.capdamunt').removeClass('amagar');
    } else {
      $('a.capdamunt').addClass('amagar');
      $('a.capdamunt').removeClass('mostrar');
    }
  });
  $('a.capdamunt').on('click', (event) => {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 600);
  });
  */
})(jQuery);
("use strict");

/**
 * A partir d'aquí Vanilla JS
 */

//AMAGAR SITE-HEADER AL FER SCROLL

var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  var element = document.getElementById("capdamunt");
  if (prevScrollpos > currentScrollPos) {
    element.classList.add("visible");
  } else {
    element.classList.remove("visible");
  }
  prevScrollpos = currentScrollPos;
};

//HAMBURGUESA

var hamburger = document.querySelector("button.hamburger");
var body = document.querySelector("body");
var navegacio = document.querySelector(".main-nav");
var registre = document.querySelector(".register-menu");
hamburger.addEventListener("click", function () {
  hamburger.classList.toggle("is-active");
  body.classList.toggle("is-active");
  navegacio.classList.toggle("is-active");
  registre.classList.toggle("is-active");
  navegacio.classList.add("is-mobile");
});


//copiar url al portaretalls
function copiar(id_element) {
  var aux = document.createElement("input");
  aux.setAttribute("value", document.getElementById(id_element).innerHTML);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");

  var olo = document.getElementById("disc").innerHTML;
  var ico =
    '<svg class="icon is-medium" style="position:relative;top:-.2rem;left:-.4rem" aria-hidden="true" focusable="false"><use xlink:href="#clipboard"></use></svg>';
  var avis = document.createElement("div");
  avis.setAttribute("id", "avis");
  avis.style.cssText =
    "position:fixed; z-index: 9999999;top: 0;left:0;right:0; background: #EDF67D;sans-serif;font-size:1.8rem;font-weight:600;padding: 2rem 1rem; text-align:center";
  avis.innerHTML = ico + olo;
  document.body.appendChild(avis);
  document.load = setTimeout("document.body.removeChild(avis)", 2000);

  document.body.removeChild(aux);
}
